import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { LanguageProvider } from './context/LanguageContext';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Tickets from './pages/Tickets';
import TicketPayment from './pages/TicketPayment';
import TicketSubscriberResponse from './pages/TicketSubscriberResponse';
import Partners from './pages/Partners';
import FAQ from './pages/FAQ';
import Contact from './pages/Contact';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import MagicLinkVerify from './pages/MagicLinkVerify';
import RegisterComplete from './pages/RegisterComplete';
import PaiementEtComptes from './pages/PaiementEtComptes';
import JuventusCard from './pages/JuventusCard';
import JuventusCardForm from './pages/JuventusCardForm';
import JuventusCardLostForm from './pages/JuventusCardLostForm';
import NewsDetail from './pages/NewsDetail';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminNews from './pages/admin/AdminNews';
import AdminPartners from './pages/admin/AdminPartners';
import AdminTickets from './pages/admin/AdminTickets';
import AdminTicketForm from './pages/admin/AdminTicketForm';
import AdminTicketSubscriberNotify from './pages/admin/AdminTicketSubscriberNotify';
import AdminTicketParticipations from './pages/admin/AdminTicketParticipations';
import AdminTicketParticipationDetail from './pages/admin/AdminTicketParticipationDetail';
import AdminTicketOrders from './pages/admin/AdminTicketOrders';
import AdminTicketOpponents from './pages/admin/AdminTicketOpponents';
import AdminUsers from './pages/admin/AdminUsers';
import AdminSubscribers from './pages/admin/AdminSubscribers';
import AdminNewMembers from './pages/admin/AdminNewMembers';
import AdminRegisterMember from './pages/admin/AdminRegisterMember';
import AdminJuventusCard from './pages/admin/AdminJuventusCard';
import AdminJuventusCardLost from './pages/admin/AdminJuventusCardLost';
import AdminEmailTemplates from './pages/admin/AdminEmailTemplates';
import AdminAutomatedEmails from './pages/admin/AdminAutomatedEmails';
import AdminAutomatedEmailEdit from './pages/admin/AdminAutomatedEmailEdit';
import AdminPricing from './pages/admin/AdminPricing';
import AdminMemberExport from './pages/admin/AdminMemberExport';
import AdminMemberSeasonCodes from './pages/admin/AdminMemberSeasonCodes';
import AdminEmailHistory from './pages/admin/AdminEmailHistory';
import UserProfile from './pages/UserProfile';
import Terms from './pages/Terms';
import PrivateRoute, { AdminRoute } from './components/PrivateRoute';
import ActiveMemberRoute from './components/ActiveMemberRoute';
import ScrollToTop from './components/ScrollToTop';
import LangQuerySync from './components/LangQuerySync';
import CustomTeamLogosLoader from './components/CustomTeamLogosLoader';
import './App.css';

function App() {
  return (
    <LanguageProvider>
    <AuthProvider>
      <Router>
        <LangQuerySync />
        <CustomTeamLogosLoader />
        <ScrollToTop />
        <div className="App">
          <Header />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/billets" element={<Tickets />} />
              <Route path="/billets/reponse/:token" element={<TicketSubscriberResponse />} />
              <Route path="/billets/paiement" element={<ActiveMemberRoute><TicketPayment /></ActiveMemberRoute>} />
              <Route path="/partenaires" element={<Partners />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/login" element={<Login />} />
              <Route path="/login/verify/:token" element={<MagicLinkVerify />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password/:token" element={<ResetPassword />} />
              <Route path="/register" element={<RegisterComplete />} />
              <Route path="/paiement-et-comptes" element={<PaiementEtComptes />} />
              <Route path="/juventus-card" element={<JuventusCard />} />
              <Route path="/juventus-card/demande" element={<ActiveMemberRoute><JuventusCardForm /></ActiveMemberRoute>} />
              <Route path="/juventus-card/perte" element={<ActiveMemberRoute><JuventusCardLostForm /></ActiveMemberRoute>} />
              <Route path="/news/:id" element={<NewsDetail />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/account" element={<PrivateRoute><UserProfile /></PrivateRoute>} />
              
              {/* Admin Routes */}
              <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
              <Route path="/admin/news" element={<AdminRoute><AdminNews /></AdminRoute>} />
              <Route path="/admin/partners" element={<AdminRoute><AdminPartners /></AdminRoute>} />
              <Route path="/admin/tickets" element={<AdminRoute><AdminTickets /></AdminRoute>} />
              <Route path="/admin/tickets/new" element={<AdminRoute><AdminTicketForm /></AdminRoute>} />
              <Route path="/admin/tickets/edit/:id" element={<AdminRoute><AdminTicketForm /></AdminRoute>} />
              <Route path="/admin/tickets/:id/subscriber-notify" element={<AdminRoute><AdminTicketSubscriberNotify /></AdminRoute>} />
              <Route path="/admin/ticket-participations" element={<AdminRoute><AdminTicketParticipations /></AdminRoute>} />
              <Route path="/admin/ticket-participations/:id" element={<AdminRoute><AdminTicketParticipationDetail /></AdminRoute>} />
              <Route path="/admin/ticket-opponents" element={<AdminRoute><AdminTicketOpponents /></AdminRoute>} />
              <Route path="/admin/ticket-orders" element={<AdminRoute><AdminTicketOrders /></AdminRoute>} />
              <Route path="/admin/users" element={<AdminRoute><AdminUsers /></AdminRoute>} />
              <Route path="/admin/subscribers" element={<AdminRoute><AdminSubscribers /></AdminRoute>} />
              <Route path="/admin/new-members" element={<AdminRoute><AdminNewMembers /></AdminRoute>} />
              <Route path="/admin/register-member" element={<AdminRoute><AdminRegisterMember /></AdminRoute>} />
              <Route path="/admin/juventus-card" element={<AdminRoute><AdminJuventusCard /></AdminRoute>} />
              <Route path="/admin/juventus-card-lost" element={<AdminRoute><AdminJuventusCardLost /></AdminRoute>} />
              <Route path="/admin/email-templates" element={<AdminRoute><AdminEmailTemplates /></AdminRoute>} />
              <Route path="/admin/mailing-auto/edit/:typeKey" element={<AdminRoute><AdminAutomatedEmailEdit /></AdminRoute>} />
              <Route path="/admin/mailing-auto" element={<AdminRoute><AdminAutomatedEmails /></AdminRoute>} />
              <Route path="/admin/pricing" element={<AdminRoute><AdminPricing /></AdminRoute>} />
              <Route path="/admin/export-members" element={<AdminRoute><AdminMemberExport /></AdminRoute>} />
              <Route path="/admin/member-season-codes" element={<AdminRoute><AdminMemberSeasonCodes /></AdminRoute>} />
              <Route path="/admin/email-history" element={<AdminRoute><AdminEmailHistory /></AdminRoute>} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
    </LanguageProvider>
  );
}

export default App;


